<iframe
  id="inlineFrameExample"
  title="Inline Frame Example"
  width="1920"
  height="1080"
  style="width: 100%; height: 90vh;"
  [src]="safeSrc">
</iframe>

  
